<template>
  <div class="wrapper shadowboxing">
    <div class="inner ibf-h2 brand_almost_black enterprise">
      <div
        :class="{ 'ib-logo-centered': !tierName }"
        class="ib-logo"
      ></div>
      <div
        v-if="tierName"
        class="ib-tier-type"
      >
        {{ tierName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicenseTier',
  props: {
    tierName: { type: String },
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.ib-logo {
  width: 35px;
  height: 33px;
  background: url('@/assets/images/user/white_logo.svg') no-repeat;
  margin: 20px auto 0 auto;

  &.ib-logo-centered {
    margin: 38px auto;
  }
}
.ib-tier-type {
  padding-top: 10px;
}
.pro {
  background: url('@/assets/images/user/Tier_Pro_proplus.svg') no-repeat;
}
.pro-plus {
  background: url('@/assets/images/user/Tier_Pro_proplus.svg') no-repeat;
}
.free {
  background: url('@/assets/images/user/Tier_Free.svg') no-repeat;
}
.enterprise {
  background: linear-gradient(70.93deg, #49deac 25.69%, #26e7de 98.99%);
}
.wrapper {
  width: 100%;
  height: 140px;
  padding: 16px;
  & .inner {
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    flex-flow: column wrap;

    &.pro,
    &.pro-plus {
      background-size: cover;
      background-position: center;
    }
    &.free {
      background-position: right;
    }
  }
}
</style>
